import browserLanguage from 'in-browser-language';
import en from 'src/locales/en.json';
import it from 'src/locales/it.json';

export const appLocales = ['de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh'];

export const messages = {
  en,
  it,
};

export const getLocale = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const qsLn = urlParams.get('ln');
  const extLn = appLocales.includes(qsLn) && qsLn;
  if (extLn) {
    window.localStorage.setItem('ln', qsLn);
  }
  return extLn || window.localStorage.getItem('ln') || browserLanguage.pick(appLocales, 'en');
};
